import type { z } from 'zod';
import type { ProjectBaseModel } from '../../projects/_models/project';

// 行革からの要望で、2025年以降の基金シートのレイアウトを変更する。
// すでに公開された内容を変更すると改ざんとみなされるので、2024年度までの事業では旧レイアウトを使用する。
export const isBefore2025 = (
  project?: Pick<z.infer<typeof ProjectBaseModel>, 'fiscalYear'>,
): boolean => {
  return !!project && project.fiscalYear < 2025;
};
